<template>
  <div>
    <emd-container :title="$t('title')">
      <template v-slot:content>
        <div class="eu-flex">
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
            <div class="emd-form-group">
              <label class="emd-label">{{ $t('shipping') }} <span class="label-optional">({{ $t('optional') }})</span></label>
              <emd-input-money
                v-model="shipping"
              />
            </div>
          </div>
        </div>
      </template>
    </emd-container>
  </div>
</template>

<script>
import EmdInputMoney from '@/components/project/EmdInputMoney'
import EmdContainer from '@/components/emerald/molecules/EmdContainer.vue'

export default {
  name: 'Shipping',
  components: {
    EmdContainer,
    EmdInputMoney
  },
  computed: {
    shipping: {
      get () {
        return this.$store.getters.paymentLinkShipping
      },
      set (newValue) {
        this.$store.dispatch('SHIPPING_VALUE', newValue)
      }
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "shipping": "Valor do frete",
    "optional": "opcional",
    "title": "Envio dos itens"
  },
  "en-US": {
    "shipping": "Shipping value",
    "optional": "optional",
    "title": "Order submission"
  }
}
</i18n>
